import { useEffect, useRef, useSyncExternalStore } from 'react';
import { type ChordFrame, getMicState, type MicFrame, type MicState, onMic } from './mic';

const subscribeState = (fn: () => void) => onMic('state', fn);

/** Microphone state; re-renders on change. */
export function useMicState(): MicState {
  return useSyncExternalStore(subscribeState, getMicState);
}

/** Calls `fn` for every analysed mic frame (~60 Hz). The latest `fn` is always used. */
export function useMicFrame(fn: (f: MicFrame) => void, enabled = true): void {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled) return;
    return onMic('frame', (f) => ref.current(f));
  }, [enabled]);
}

/** Calls `fn` for every chroma frame (~11 Hz). Chroma is only computed while someone listens. */
export function useMicChord(fn: (c: ChordFrame) => void, enabled = true): void {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled) return;
    return onMic('chord', (c) => ref.current(c));
  }, [enabled]);
}
